import { useSelector } from 'react-redux';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import DetailsPanel from '../../../generic/DetailsPanel';
import Section from '../../../shared/vulns/Drawer/Section';
import DependencyDepthMessage from '../DependencyDepthMessage';

import issueContentStyles from '../IssueContent.module.less';
import styles from './Licensing.module.less';

/**
 * Main issue details for licensing issues.
 *
 * Displays the reason this issue was raised, as well as the depth at which
 * the source package is used, as well as the issue notes if they exist.
 */
const LicensingIssueDetailsIssueDetails = () => {
  const licensingIssueDetails = useSelector(IssuesV2Store.selectors.getLicensingIssueDetails);
  if (!licensingIssueDetails) {
    return null;
  }
  const { reason, depthMessages, notes } = licensingIssueDetails;
  // Can't put this logic in the selector because IssueIndex contains JSX and interferes
  // with the unit tests.
  return (
    <Section>
      <DetailsPanel
        id="issue-details-licensing-details"
        target="Issue details"
      >
        <div className={issueContentStyles.issueDetails}>
          <div>
            {reason}
          </div>
          {depthMessages && (
            <DependencyDepthMessage depthMessages={depthMessages} />
          )}
          {notes &&
            <div className={styles.notes}>
              {notes}
            </div>}
        </div>
      </DetailsPanel>
    </Section>
  );
};

export default LicensingIssueDetailsIssueDetails;
